export default {
  COMMENTS_MODAL: {
    TITLE: `Commentaires`,
    SUMMARY: ``
  },
  COMMENTS: {
    TITLE: `Commentaires`,
    SUMMARY: ``
  },
  DELETE_BUTTON: {
    TITLE: `Supprimer le commentaire`,
    SUMMARY: `Êtes-vous certain de vouloir supprimer ce commentaire?`,
    PRIMARY_ACTION: `Supprimer le commentaire`
  },
  PUNCHIN_COMMENT: `Commentaire de poinçon d'entrée`,
  TRANSFER_COMMENTS: `Commentaires de transferts`,
  PUNCHOUT_COMMENT: `Commentaire de poinçon de sortie`,
  EDIT_HISTORY: `Historique des modifications`,
  NO_COMMENTS: `Aucun commentaire`,
  COMMENT_UPDATED_SUCCESSFULLY: `Le commentaire a été mis à jour avec succès!`,
  COMMENT_NOT_UPDATED_SUCCESSFULLY: `Le commentaire n'a pas pu être mis à jour, veuillez réessayer`,
  COMMENT_ADDED_SUCCESSFULLY: `Le commentaire a été ajouté avec succès!`,
  COMMENT_NOT_ADDED_SUCCESSFULLY: `Le commentaire n'a pas pu être ajouté, veuillez réessayer`,
  COMMENT_DELETED_SUCCESSFULLY: `Le commentaire a été supprimé avec succès!`,
  COMMENT_NOT_DELETED_SUCCESSFULLY: `Le commentaire n'a pas pu être supprimé, veuillez réessayer`,
  SHOW_EDITS: 'Afficher les modifications',
  ADDED_NEW_COMMENT: `commentaire ajouté`,
  UPDATED_COMMENT: `commentaire mis à jour`,
  INPUT_COMMENT_PLACEHOLDER: `Écrivez un commentaire...`,
  DELETE_CONFIRMATION: `Voulez-vous vraiment supprimer ce commentaire?`,
  MODAL_CONTENT_LABEL: `Historique des commentaires`,
  QUIT_PAGE: `Les modifications apportées n'ont pas été sauvegardées. Souhaitez-vous quitter quand même?`
}
